import { AchievementName, LearnerAchievementFragment } from '@/__generated__/graphql';
import NumberCount, { NumberCountEnum } from '@/components/NumberCount';
import time, { FORMAT_DATE_VN } from '@flyer/utils/time';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { useMemo } from 'react';

import achievements1Disable from '@/assets/images/achievements/Baihochoanhao.png';
import achievements1 from '@/assets/images/achievements/Baihochoanhao1.png';
import achievements2Disable from '@/assets/images/achievements/Chuoidainhat.png';
import achievements2 from '@/assets/images/achievements/Chuoidainhat1.png';
import achievements3Disable from '@/assets/images/achievements/MVP.png';
import achievements3 from '@/assets/images/achievements/MVP1.png';
import achievements4Disable from '@/assets/images/achievements/Nhieustar.png';
import achievements4 from '@/assets/images/achievements/Nhieustar1.png';
import { twMerge } from 'tailwind-merge';

function Achievement({
  dataListAchievement,
}: {
  dataListAchievement?: LearnerAchievementFragment[];
}) {
  const { t, lang } = useTranslation('common');

  const listAchievements = useMemo(() => {
    return [
      {
        dataImage: achievements2,
        dataImageDisable: achievements2Disable,
        key: AchievementName.LongestChain,
        title: t('achievements.personal_achievements.longest_chain'),
        descriptionAchievements:
          'achievements.personal_achievements.description_achievements_longest_chain',
        descriptionAchievements_more: null,
        descriptionAchievementsDisable:
          'achievements.personal_achievements.description_achievements_longest_chain_disable',
        numberType: NumberCountEnum.Violet,
      },
      {
        dataImage: achievements4,
        dataImageDisable: achievements4Disable,
        title: t('achievements.personal_achievements.stars_hunter_warlord'),
        descriptionAchievements:
          'achievements.personal_achievements.description_achievements_stars_hunter_warlord',
        descriptionAchievements_more:
          'achievements.personal_achievements.description_achievements_stars_hunter_warlord_more',
        descriptionAchievementsDisable:
          'achievements.personal_achievements.description_achievements_stars_hunter_warlord_disable',
        key: AchievementName.StarsHunterWarlord,
        numberType: NumberCountEnum.SmashedPumpkin,
      },
      {
        dataImage: achievements1,
        dataImageDisable: achievements1Disable,
        title: t('achievements.personal_achievements.perfect_lessons'),
        descriptionAchievements:
          'achievements.personal_achievements.description_achievements_perfect_lessons',
        descriptionAchievements_more: null,
        descriptionAchievementsDisable:
          'achievements.personal_achievements.description_achievements_perfect_lessons_disable',
        key: AchievementName.PerfectLessons,
        numberType: NumberCountEnum.GreenPantone,
      },
      {
        dataImage: achievements3,
        dataImageDisable: achievements3Disable,
        title: t('achievements.personal_achievements.tournament_star'),
        descriptionAchievements:
          'achievements.personal_achievements.description_achievements_tournament_star',
        descriptionAchievements_more: null,
        descriptionAchievementsDisable:
          'achievements.personal_achievements.description_achievements_tournament_star_disable',
        key: AchievementName.TournamentStar,
        numberType: NumberCountEnum.Orange,
      },
    ];
  }, [t]);

  return (
    <div className="p-3 w-full md:w-[50%] bg-[#F9F8FF] rounded-[8px]">
      <p className="text-[#000] text-[17px] text-left">
        {t('achievements.personal_achievements.title')}
      </p>
      <div className="flex flex-row items-center h-[90%]">
        {listAchievements.map((item) => {
          const dataCurrentAchievement = dataListAchievement?.find((i) => i.name === item.key);
          const isDisable = !dataCurrentAchievement?.value;
          return (
            <div
              aria-hidden
              key={item.title}
              className="flex flex-col justify-between items-center px-4 py-3 cursor-pointer min-w-[75px]"
            >
              <Image
                alt="flyer"
                src={isDisable ? item.dataImageDisable : item.dataImage}
                className="h-[84px] w-auto object-contain"
                property="100"
              />
              <div className="mt-[-18px]">
                <NumberCount
                  number={dataCurrentAchievement?.value || 0}
                  customClassName="w-[24px] h-auto"
                  type={isDisable ? NumberCountEnum.LavenderPurple : item.numberType}
                />
              </div>
              {/* <p className="text-base font-bold pt-1 text-center">{item.title}</p> */}
              {/* <p */}
              {/*  className={twMerge( */}
              {/*    'text-[#745AE8] text-xs pt-1', */}
              {/*    dataCurrentAchievement?.dateReceived ? '' : 'opacity-0', */}
              {/*  )} */}
              {/* > */}
              {/*  {dataCurrentAchievement?.dateReceived */}
              {/*    ? time(dataCurrentAchievement?.dateReceived) */}
              {/*        .locale(lang) */}
              {/*        .format(lang === 'vi' ? FORMAT_DATE_VN : 'MMMM DD, YYYY') */}
              {/*    : 'invalid date'} */}
              {/* </p> */}
            </div>
          );
        })}
      </div>
    </div>
  );
}
export default Achievement;
